
import { createHashRouter } from 'react-router-dom'
import Index from '../views/Index';
import Presentation from '../views/About';
import Noticias from '../views/News';
import DetalhesNoticia from '../views/DetalhesNoticias';
import AreasPratica from '../views/AreaPratica';
import Contactos from '../views/Contact';
import NotFound from '../views/404';
import Candidaturas from '../views/Candidaturas';

const routes = createHashRouter([
    {
        path:"/",
        element:<Index/>
    },
    {
        path:"/sobre",
        element:<Presentation/>
    },
    {
        path:"/noticias",
        element:<Noticias/>
    },
    {
        path:"/noticias/detalhes/:id",
        element:<DetalhesNoticia/>
    },
    {
        path:"/areas-pratica",
        element:<AreasPratica/>
    },
    {
        path:"/contactos",
        element:<Contactos/>
    },
    {
        path:"/candidaturas",
        element:<Candidaturas/>
    },
    {
        path:"*",
        element:<NotFound/>
    },
])

export default routes;